@layer design-system {
  .stickyHeader {
    padding: 6px 12px;
    border-bottom: 1px solid var(--border-default);
    z-index: var(--z-index-header-cell);
    position: sticky;
    left: 0;
    top: 0;

    &.pinned {
      z-index: calc(var(--z-index-header-cell) + 1);
      top: 0;
    }

    &.lastPinned {
      border-right: 1px solid var(--border-default);
    }
  }

  .contentContainer {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
